import {PlanningNode} from './planning-node';
import {PlanningCable} from './planning-cable';
import { PlanningSwitchingState } from './cable-switching-state';
import { PlanningTrafoDtos } from './planning-trafo-dtos';


export class GPlanInput  {
  public id: number;
  public intervalStart: string;
  public intervalEnd: string;
  public topologyId: string;
  public planningNodes: Array<PlanningNode> = new Array<PlanningNode>();
  public planningCables: Array<PlanningCable> = new Array<PlanningCable>();
  public planningSwichtingStates: Array<PlanningSwitchingState> = new Array<PlanningSwitchingState>();
  public planningSubgridsDtos: Array<PlanningSwitchingState> = new Array<PlanningSwitchingState>();
  public name: string;
  public voltageAtRoot: number;
  public deratingFactorExistingGenerator: number;
  public powerFactorExistingGenerator: number;
  public type: string;
  public planningTrafoDtos: Array<PlanningTrafoDtos> = new Array<PlanningTrafoDtos>();
  public useTimeseriesData: string;
}
